<!-- Resume Analysis Modal - New Design -->
<!-- This content will be portaled to document.body when open -->
<!-- data-lenis-prevent: allow native scroll inside modal (Lenis would otherwise capture wheel/touch) -->
<div *ngIf="isOpen" class="fixed inset-0 overflow-y-auto" data-lenis-prevent>
  <!-- Backdrop -->
  <div class="fixed inset-0 bg-black/50 dark:bg-black/70 backdrop-blur-sm" (click)="closeModal()"></div>

  <div class="relative flex min-h-screen md:items-center justify-center p-3 md:p-4" (click)="closeModal()">
    <!-- Modal Container with gradient background -->
    <div 
      class="relative max-w-4xl w-full max-h-[90vh] overflow-y-auto rounded-2xl shadow-2xl bg-gradient-to-b from-[#DCEBEF] to-white dark-gradient-bg dark-gradient-border-always"
      (click)="$event.stopPropagation()"
    >
      <!-- 1. HEADER (transparent, on gradient) -->
      <div class="px-4 md:px-6 py-4 md:py-5">
        <div class="flex items-start justify-between">
          <div class="flex-1 pr-8">
            <h2 class="text-lg md:text-xl font-bold text-gray-900 dark:text-white mb-1">
              Resume analysis
            </h2>
            <p class="text-xs md:text-sm text-gray-500 dark:text-gray-400">
              <span class="font-medium">{{ result.jobTitle || 'Job Position' }}</span>
              <span class="mx-1">&#64;</span>
              <span class="font-medium">{{ result.company || 'Company' }}</span>
              <span class="mx-2">•</span>
              <span>{{ result.resumeFileName || 'Resume.pdf' }}</span>
            </p>
          </div>
          <button
            (click)="closeModal()"
            class="absolute top-4 right-4 md:top-5 md:right-6 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
          >
            <hugeicons-icon
              [icon]="icons.cancel"
              [size]="20"
              color="currentColor"
              [strokeWidth]="2"
              class="block"
            />
          </button>
        </div>
      </div>

      <!-- Content Area (all on gradient) -->
      <div class="px-4 md:px-6 pt-0 pb-4 md:pb-6 space-y-4 md:space-y-6">

        <!-- 2. OVERVIEW CARD -->
        <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 md:p-5">
            <div class="flex flex-col md:flex-row items-center gap-4 md:gap-8">
            <!-- Right side - Score gauge with SVG chart (shows first on mobile) -->
            <div class="relative flex flex-col items-center justify-start flex-shrink-0 w-full md:w-80 order-1 md:order-2">
              <!-- SVG Chart with Gradients -->
              <div class="relative w-full h-36 mb-4">
                <svg viewBox="0 0 283 174" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full h-full mx-auto">
                  <!-- Gradient definitions -->
                  <defs>
                    <!-- Red segment gradient (0-25%) -->
                    <linearGradient id="gradRed" x1="70" y1="30" x2="30" y2="170" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#FA941A"/>
                      <stop offset="1" stop-color="#CF5069"/>
                    </linearGradient>
                    <!-- Orange segment gradient (25-50%) -->
                    <linearGradient id="gradOrange" x1="100" y1="20" x2="160" y2="50" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#FA941A"/>
                      <stop offset="1" stop-color="#E5C500"/>
                    </linearGradient>
                    <!-- Yellow segment gradient (50-75%) -->
                    <linearGradient id="gradYellow" x1="180" y1="40" x2="230" y2="100" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#E5C500"/>
                      <stop offset="1" stop-color="#B8D400"/>
                    </linearGradient>
                    <!-- Green segment gradient (75-100%) -->
                    <linearGradient id="gradGreen" x1="240" y1="80" x2="260" y2="170" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#8DBE00"/>
                      <stop offset="1" stop-color="#5A8A30"/>
                    </linearGradient>
                    
                    <!-- Clip path that clips to the "filled" portion based on score -->
                    <!-- This creates a wedge from center that covers 0% to score% of the arc -->
                    <clipPath id="scoreClip">
                      <path [attr.d]="getScoreClipPath(result.atsScore)" />
                    </clipPath>
                  </defs>
                  
                  <!-- Dashed background arc -->
                  <path 
                    d="M253.762 149.592C254.533 154.885 254.947 160.255 254.993 165.666L254.496 165.67C254.499 166.004 254.5 166.339 254.5 166.674H253.58C253.58 166.342 253.578 166.01 253.575 165.678L253.075 165.682H253.073C253.028 160.363 252.62 155.085 251.862 149.881L252.358 149.809C252.263 149.152 252.162 148.495 252.055 147.84L251.562 147.921H251.559C250.704 142.684 249.496 137.528 247.946 132.49H247.948L248.427 132.343C248.232 131.709 248.031 131.076 247.825 130.445L247.35 130.6H247.348C245.705 125.567 243.721 120.657 241.41 115.907L241.413 115.906L241.862 115.687C241.572 115.09 241.276 114.496 240.976 113.905L240.529 114.131C238.137 109.422 235.419 104.877 232.392 100.532L232.394 100.531L232.805 100.246C232.425 99.7012 232.04 99.1589 231.651 98.6207L231.246 98.9137H231.245C228.159 94.6446 224.768 90.579 221.087 86.7506L221.089 86.7496L221.45 86.4029C221.22 86.1636 220.988 85.9255 220.756 85.6881C220.527 85.4538 220.296 85.2209 220.065 84.9888L219.711 85.3414L219.709 85.3424C216.003 81.6195 212.069 78.1859 207.94 75.0582H207.941L208.244 74.6597C207.722 74.2641 207.196 73.8728 206.668 73.4869L206.373 73.8912L206.371 73.8922C202.142 70.8034 197.718 68.029 193.134 65.5836L193.135 65.5826L193.37 65.1412C192.792 64.833 192.212 64.5297 191.63 64.232L191.402 64.6773L191.401 64.6783C186.751 62.302 181.944 60.2613 177.016 58.5699L177.017 58.5679L177.179 58.0953C176.559 57.8828 175.938 57.6757 175.315 57.4742L175.161 57.9498H175.16C170.207 56.3478 165.136 55.0988 159.985 54.2144L159.986 54.2125L160.07 53.7193C159.425 53.6086 158.779 53.5041 158.132 53.4049L158.056 53.898C152.927 53.1116 147.722 52.69 142.478 52.6431L142.479 52.6412L142.482 52.1412C142.155 52.1383 141.828 52.1373 141.5 52.1373C141.172 52.1373 140.845 52.1383 140.518 52.1412L140.521 52.6412V52.6431C135.277 52.6901 130.072 53.1115 124.943 53.898L124.868 53.4049C124.221 53.5041 123.575 53.6086 122.93 53.7193L123.014 54.2125V54.2144C117.863 55.0989 112.792 56.3477 107.839 57.9498L107.685 57.4742C107.062 57.6757 106.441 57.8828 105.821 58.0953L105.983 58.5679V58.5699C101.055 60.2613 96.2478 62.302 91.5977 64.6783V64.6773L91.3701 64.232C90.7875 64.5297 90.2075 64.833 89.6299 65.1412L89.8652 65.5826V65.5836C85.2814 68.029 80.8573 70.8033 76.6279 73.8922L76.627 73.8912L76.332 73.4869C75.8036 73.8728 75.2782 74.2641 74.7559 74.6597L75.0586 75.0582C70.9298 78.1859 66.9964 81.6195 63.29 85.3424L63.2891 85.3414L62.9346 84.9888L62.2441 85.6881C62.0118 85.9255 61.7799 86.1636 61.5498 86.4029L61.9111 86.7496L61.9121 86.7506C58.2314 90.579 54.8398 94.6446 51.7539 98.9137L51.3486 98.6207C50.9596 99.1588 50.5746 99.7002 50.1953 100.245L50.6064 100.531L50.6074 100.532C47.5802 104.877 44.8618 109.422 42.4697 114.131L42.0244 113.905C41.7239 114.496 41.428 115.09 41.1377 115.687L41.5869 115.906L41.5889 115.907C39.278 120.657 37.2937 125.567 35.6514 130.6H35.6504L35.1748 130.445C34.969 131.076 34.7683 131.709 34.5732 132.343L35.0518 132.49H35.0527C33.5035 137.528 32.2947 142.684 31.4404 147.921H31.4385L30.9453 147.84C30.8385 148.495 30.7373 149.152 30.6416 149.809L31.1367 149.88C30.3787 155.084 29.971 160.363 29.9258 165.682H29.9248L29.4248 165.678C29.422 166.01 29.4199 166.342 29.4199 166.674H28.5C28.5 166.339 28.5011 166.004 28.5039 165.67L28.0059 165.666C28.0479 160.719 28.3978 155.806 29.0469 150.956L29.2373 149.592" 
                    stroke="#E0E0E0" 
                    stroke-width="0.5" 
                    stroke-dasharray="2 8"
                    fill="none"
                  />
                  
                  <!-- FADED BACKGROUND: All segments at reduced opacity -->
                  <g opacity="0.3">
                    <!-- Red segment: 0-25% -->
                  <path 
                    d="M8.27241 173.695C3.86314 173.977 0.0363538 170.628 0.00383329 166.21C-0.251341 131.543 12.2407 97.8765 35.2629 71.7084C58.2852 45.5404 90.0861 28.8616 124.504 24.6987C128.89 24.1682 132.698 27.5373 132.98 31.9466L133 32.2507C133.282 36.66 129.929 40.4367 125.547 40.9995C95.4472 44.8653 67.6697 59.5577 47.5045 82.4783C27.3392 105.399 16.3049 134.822 16.3048 165.169C16.3048 169.587 12.9858 173.393 8.57657 173.675L8.27241 173.695Z" 
                    fill="url(#gradRed)"
                    />
                    <!-- Orange segment: 25-50% -->
                    <path 
                      d="M135.848 31.7941C135.661 27.3798 139.09 23.6259 143.508 23.6885C170.316 24.0684 196.471 32.0598 218.913 46.7282C222.612 49.1454 223.357 54.1749 220.735 57.7309L220.554 57.9761C217.932 61.5321 212.936 62.2652 209.22 59.8753C189.796 47.3825 167.287 40.5053 144.198 40.0081C139.78 39.913 136.048 36.5129 135.861 32.0986L135.848 31.7941Z" 
                      fill="url(#gradOrange)"
                    />
                    <!-- Yellow segment: 50-75% -->
                    <path 
                      d="M223.272 59.6488C225.978 56.1564 231.02 55.5023 234.354 58.4016C247.027 69.4226 257.637 82.6127 265.687 97.3528C267.805 101.23 266.086 106.015 262.095 107.91L261.819 108.041C257.828 109.936 253.079 108.222 250.933 104.36C244.015 91.9128 235.024 80.7359 224.348 71.3123C221.035 68.3885 220.379 63.3822 223.085 59.8898L223.272 59.6488Z" 
                      fill="url(#gradYellow)"
                    />
                    <!-- Green segment: 75-100% -->
                    <path 
                      d="M262.676 109.152C266.687 107.297 271.464 109.038 273.088 113.147C279.768 130.042 283.132 148.066 282.996 166.233C282.963 170.651 279.136 173.998 274.727 173.715L274.422 173.696C270.013 173.413 266.695 169.608 266.695 165.189C266.697 149.735 263.838 134.413 258.261 120.001C256.667 115.88 258.389 111.134 262.4 109.28L262.676 109.152Z" 
                      fill="url(#gradGreen)"
                    />
                  </g>
                  
                  <!-- FILLED FOREGROUND: Full opacity segments clipped to score position -->
                  <g clip-path="url(#scoreClip)">
                    <!-- Red segment: 0-25% -->
                    <path 
                      d="M8.27241 173.695C3.86314 173.977 0.0363538 170.628 0.00383329 166.21C-0.251341 131.543 12.2407 97.8765 35.2629 71.7084C58.2852 45.5404 90.0861 28.8616 124.504 24.6987C128.89 24.1682 132.698 27.5373 132.98 31.9466L133 32.2507C133.282 36.66 129.929 40.4367 125.547 40.9995C95.4472 44.8653 67.6697 59.5577 47.5045 82.4783C27.3392 105.399 16.3049 134.822 16.3048 165.169C16.3048 169.587 12.9858 173.393 8.57657 173.675L8.27241 173.695Z" 
                      fill="url(#gradRed)"
                  />
                  <!-- Orange segment: 25-50% -->
                  <path 
                    d="M135.848 31.7941C135.661 27.3798 139.09 23.6259 143.508 23.6885C170.316 24.0684 196.471 32.0598 218.913 46.7282C222.612 49.1454 223.357 54.1749 220.735 57.7309L220.554 57.9761C217.932 61.5321 212.936 62.2652 209.22 59.8753C189.796 47.3825 167.287 40.5053 144.198 40.0081C139.78 39.913 136.048 36.5129 135.861 32.0986L135.848 31.7941Z" 
                    fill="url(#gradOrange)"
                  />
                  <!-- Yellow segment: 50-75% -->
                  <path 
                    d="M223.272 59.6488C225.978 56.1564 231.02 55.5023 234.354 58.4016C247.027 69.4226 257.637 82.6127 265.687 97.3528C267.805 101.23 266.086 106.015 262.095 107.91L261.819 108.041C257.828 109.936 253.079 108.222 250.933 104.36C244.015 91.9128 235.024 80.7359 224.348 71.3123C221.035 68.3885 220.379 63.3822 223.085 59.8898L223.272 59.6488Z" 
                    fill="url(#gradYellow)"
                  />
                  <!-- Green segment: 75-100% -->
                  <path 
                    d="M262.676 109.152C266.687 107.297 271.464 109.038 273.088 113.147C279.768 130.042 283.132 148.066 282.996 166.233C282.963 170.651 279.136 173.998 274.727 173.715L274.422 173.696C270.013 173.413 266.695 169.608 266.695 165.189C266.697 149.735 263.838 134.413 258.261 120.001C256.667 115.88 258.389 111.134 262.4 109.28L262.676 109.152Z" 
                    fill="url(#gradGreen)"
                  />
                  </g>
                  
                  <!-- Dynamic dot marker -->
                  <circle 
                    [attr.cx]="getDotPosition(result.atsScore).x" 
                    [attr.cy]="getDotPosition(result.atsScore).y" 
                    r="14" 
                    fill="white" 
                    [attr.stroke]="getDotColor(result.atsScore)" 
                    stroke-width="6"
                  />
                </svg>
                
                <!-- Score text overlay -->
                <div class="absolute inset-0 flex items-center justify-center" style="margin-top: 20px;">
                  <span class="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">{{ result.atsScore }}%</span>
                </div>
              </div>

              <!-- Score label - positioned absolutely inside the gauge -->
              <div class="absolute inset-x-0 text-center" style="bottom: 2px;">
                <div class="text-sm md:text-base font-semibold text-gray-900 dark:text-white mb-0.5">
                  {{ getScoreLabel(result.atsScore).emoji }} {{ getScoreLabel(result.atsScore).label }}
                </div>
                <button class="relative group text-[11px] md:text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 inline-flex items-center gap-1">
                  <hugeicons-icon
                    [icon]="icons.information"
                    [size]="12"
                    color="currentColor"
                    [strokeWidth]="2"
                    class="block"
                  />
                  How is it scored?
                  
                  <!-- Tooltip -->
                  <div class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 text-xs font-medium text-white bg-gray-900 dark:bg-gray-700 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50 w-48">
                    <div class="text-center">
                      We calculate your score based on keywords, skills, experience, and formatting quality.
                    </div>
                    <!-- Tooltip arrow -->
                    <div class="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900 dark:border-t-gray-700"></div>
                  </div>
                </button>
              </div>
            </div>

            <!-- Left side - Overview text (shows second on mobile, centered vertically) -->
            <div class="flex-1 max-w-md flex items-center justify-center order-2 md:order-1 md:pl-2">
              <div class="text-left w-full">
                <h3 class="text-base md:text-[18px] font-bold text-gray-900 dark:text-white mb-0.5">Overview</h3>
                <p class="text-sm md:text-base text-gray-700 dark:text-gray-300 leading-relaxed">
                  <ng-container *ngFor="let segment of parseHighlights(result.overview || result.analysisSummary || '')">
                    <span 
                      *ngIf="!segment.highlight"
                      >{{ segment.text }}</span>
                    <span 
                      *ngIf="segment.highlight"
                      class="bg-blue-100 dark:bg-purple-900/30 text-gray-900 dark:text-purple-200 px-1 py-0.5 rounded font-semibold"
                      >{{ segment.text }}</span>
                  </ng-container>
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- 3. STATS ROW -->
        <div class="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3">
          <!-- Action Required -->
          <div (click)="scrollToActionRequired()" class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-2 md:p-5 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-500 transition-colors">
            <div class="text-[9px] md:text-[11px] uppercase tracking-wide text-gray-500 dark:text-gray-400 md:mb-1 font-medium">
              ACTION
            </div>
            <div class="flex items-center gap-1 md:gap-2 mb-0">
              <span class="text-sm md:text-xl">⚠️</span>
              <span class="text-xl md:text-3xl font-bold text-gray-900 dark:text-white md:mb-1">
                {{ result.stats?.actionRequiredCount || result.actionRequired?.length || 0 }}
              </span>
            </div>
            <div class="text-[10px] md:text-[13px] font-medium" style="color: #FF6F00;">
              Immediate attention
            </div>
          </div>

          <!-- Passed Checks -->
          <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-2 md:p-5">
            <div class="text-[9px] md:text-[11px] uppercase tracking-wide text-gray-500 dark:text-gray-400 md:mb-1 font-medium">
              PASSED
            </div>
            <div class="flex items-center gap-1 md:gap-2 mb-0">
              <span class="text-sm md:text-xl">✅</span>
              <span class="text-xl md:text-3xl font-bold text-gray-900 dark:text-white md:mb-1">
                {{ result.stats?.passedChecksCount || 10 }}
              </span>
            </div>
            <div class="text-[10px] md:text-[13px] text-green-600 dark:text-green-400 font-medium">
              Strong formatting & basics
            </div>
          </div>

          <!-- Experiences Match -->
          <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-2 md:p-5">
            <div class="text-[9px] md:text-[11px] uppercase tracking-wide text-gray-500 dark:text-gray-400 md:mb-1 font-medium">
              EXPERIENCES
            </div>
            <div class="text-xl md:text-3xl font-bold text-gray-900 dark:text-white md:mb-1">
              {{ result.stats?.experiencesMatchPercent || result.experienceMatchScore }}%
            </div>
            <div class="text-[10px] md:text-[13px] text-gray-600 dark:text-gray-400">
              {{ getExperienceMatchText() }}
            </div>
          </div>

          <!-- Skills Match -->
          <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-2 md:p-5">
            <div class="text-[9px] md:text-[11px] uppercase tracking-wide text-gray-500 dark:text-gray-400 md:mb-1 font-medium">
              SKILLS
            </div>
            <div class="text-xl md:text-3xl font-bold text-gray-900 dark:text-white md:mb-1">
              {{ result.stats?.skillsMatchPercent || result.skillsMatchScore }}%
            </div>
            <div class="text-[10px] md:text-[13px] text-gray-600 dark:text-gray-400">
              {{ getSkillsMatchText() }}
            </div>
          </div>
        </div>

        <!-- 4. WHAT ARE YOU DOING WELL -->
        <div *ngIf="result.doingWell && result.doingWell.length > 0" class="bg-orange-50 dark:bg-yellow-900/20 rounded-lg p-4 md:p-5 border border-orange-200 dark:border-yellow-800 overflow-hidden">
          <div class="flex flex-col md:flex-row items-start gap-4 md:gap-6">
            <!-- Left side - List -->
            <div class="flex-1 w-full">
              <h3 class="text-sm md:text-base font-bold text-gray-900 dark:text-white mb-2 md:mb-3">
                What are you doing well 👍
              </h3>
              <div class="space-y-2">
                <div 
                  *ngFor="let item of getVisibleDoingWell(); let i = index"
                  class="flex items-start gap-2 md:gap-2.5 transition-all duration-300 ease-in-out"
                  [class.animate-fadeIn]="i >= 3 && showAllDoingWell"
                >
                  <div class="flex-shrink-0 mt-0.5">
                    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="md:w-5 md:h-5">
                      <g clip-path="url(#clip0_149_1439)">
                        <path d="M15.4447 3.54197C15.6347 4.00136 15.9993 4.36651 16.4584 4.55716L18.0683 5.22398C18.5277 5.41428 18.8927 5.7793 19.083 6.23872C19.2733 6.69815 19.2733 7.21436 19.083 7.67379L18.4167 9.28249C18.2263 9.74212 18.226 10.2589 18.4173 10.7183L19.0824 12.3265C19.1768 12.554 19.2254 12.7979 19.2254 13.0443C19.2254 13.2906 19.1769 13.5345 19.0827 13.7621C18.9884 13.9897 18.8502 14.1965 18.676 14.3706C18.5018 14.5448 18.295 14.6829 18.0674 14.7771L16.4587 15.4434C15.9993 15.6334 15.6341 15.998 15.4435 16.4571L14.7767 18.067C14.5864 18.5264 14.2213 18.8914 13.7619 19.0817C13.3025 19.272 12.7863 19.272 12.3269 19.0817L10.7181 18.4153C10.2587 18.2255 9.74269 18.2259 9.28353 18.4164L7.67367 19.0823C7.2145 19.2722 6.69874 19.272 6.23969 19.0818C5.78063 18.8917 5.41582 18.5271 5.22539 18.0682L4.55837 16.4578C4.36842 15.9985 4.00381 15.6333 3.5447 15.4427L1.93484 14.7758C1.47561 14.5856 1.11071 14.2208 0.920338 13.7617C0.729967 13.3025 0.729708 12.7865 0.91962 12.3272L1.58597 10.7185C1.7758 10.259 1.77541 9.74301 1.58489 9.28386L0.919499 7.67284C0.82516 7.44529 0.776583 7.20139 0.776543 6.95506C0.776504 6.70873 0.825002 6.4648 0.919269 6.23723C1.01353 6.00965 1.15172 5.80287 1.32593 5.62872C1.50014 5.45457 1.70696 5.31645 1.93457 5.22225L3.54327 4.55591C4.00226 4.36612 4.3672 4.00197 4.55798 3.5434L5.22481 1.93354C5.41511 1.47411 5.78012 1.10909 6.23955 0.918794C6.69898 0.728492 7.21519 0.728492 7.67461 0.918794L9.28332 1.58514C9.74276 1.77497 10.2588 1.77459 10.7179 1.58406L12.3285 0.919827C12.7878 0.729633 13.3039 0.729672 13.7633 0.919935C14.2226 1.1102 14.5876 1.47511 14.7779 1.93442L15.4449 3.54475L15.4447 3.54197Z" fill="#64901E"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9166 7.37864C14.0502 7.16879 14.0949 6.91446 14.041 6.6716C13.9871 6.42874 13.8389 6.21724 13.6291 6.08364C13.4192 5.95004 13.1649 5.90527 12.922 5.95919C12.6792 6.0131 12.4677 6.16129 12.3341 6.37114L8.66283 12.1399L6.98283 10.0399C6.82751 9.84562 6.60138 9.72101 6.35418 9.69346C6.10699 9.66592 5.85897 9.7377 5.6647 9.89302C5.47043 10.0483 5.34582 10.2745 5.31827 10.5217C5.29073 10.7689 5.36251 11.0169 5.51783 11.2111L8.01783 14.3361C8.111 14.4528 8.23066 14.5454 8.36687 14.6065C8.50308 14.6675 8.65189 14.6951 8.80093 14.6871C8.94998 14.679 9.09494 14.6355 9.22376 14.5601C9.35258 14.4847 9.46154 14.3796 9.54158 14.2536L13.9166 7.37864V7.37864Z" fill="white"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_149_1439">
                          <rect width="20" height="20" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <span class="text-sm md:text-[16px] text-gray-700 dark:text-gray-300">
                    <ng-container *ngFor="let segment of parseHighlights(item)">
                      <span 
                        *ngIf="!segment.highlight"
                        >{{ segment.text }}</span>
                      <strong 
                        *ngIf="segment.highlight"
                        class="font-bold text-gray-900 dark:text-white"
                        >{{ segment.text }}</strong>
                    </ng-container>
                  </span>
                </div>
              </div>
              
              <!-- Show more/less button -->
              <button 
                *ngIf="result.doingWell.length > 3"
                (click)="toggleDoingWell()"
                class="mt-3 text-xs md:text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:underline font-medium transition-all duration-200"
              >
                {{ showAllDoingWell ? 'Show less' : 'Show more' }}
              </button>
            </div>

            <!-- Right side - Illustration (shows at bottom on mobile) -->
            <div class="relative flex-shrink-0 h-24 w-full md:h-32 md:w-64 flex justify-center md:justify-end">
              <img 
                [src]="getDoingWellImage()" 
                alt="Celebration illustration" 
                class="w-[180px] h-[120px] md:w-[260px] md:h-[180px] md:absolute md:bottom-[-70px] md:right-5"
              />
            </div>
          </div>
        </div>

        <!-- 5. ACTION REQUIRED -->
        <div id="action-required-section" class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 md:p-5">
          <div class="mb-3 md:mb-4">
            <h3 class="text-base md:text-[18px] font-bold text-gray-900 dark:text-white mb-0.5">
              Action required ⚠️
            </h3>
            <p class="text-sm md:text-base text-gray-600 dark:text-gray-400">
              {{ result.actionRequired?.length ? 'These issues may prevent your resume from passing ATS filters. Address these first.' : 'No critical issues found!' }}
            </p>
          </div>

          <!-- Has action items -->
          <div *ngIf="result.actionRequired?.length" class="space-y-3 md:space-y-4">
            <div 
              *ngFor="let item of result.actionRequired"
              class="rounded-lg overflow-hidden border-l-4 p-3 md:p-5"
              [ngClass]="{
                'bg-red-50 dark:bg-red-900/40 border-red-500': item.priority === 'high',
                'bg-yellow-50 dark:bg-yellow-900/40 border-yellow-500': item.priority === 'medium'
              }"
            >
              <div class="flex items-center gap-2 mb-1">
                <span class="font-semibold text-sm md:text-base text-gray-900 dark:text-white">{{ item.category }}</span>
                <span 
                  class="px-2 py-0.5 rounded text-[9px] md:text-[10px] font-bold uppercase"
                  [ngClass]="{
                    'bg-red-200 dark:bg-red-900 text-red-800 dark:text-red-200': item.priority === 'high',
                    'bg-yellow-200 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200': item.priority === 'medium'
                  }"
                >
                  {{ item.priority === 'high' ? 'High priority' : 'Medium priority' }}
                </span>
              </div>
              <p class="text-xs md:text-sm text-gray-700 dark:text-gray-300 mb-2 md:mb-3">
                <ng-container *ngFor="let segment of parseHighlights(item.description)">
                  <span 
                    *ngIf="!segment.highlight"
                    >{{ segment.text }}</span>
                  <strong 
                    *ngIf="segment.highlight"
                    class="font-bold text-gray-900 dark:text-white"
                    >{{ segment.text }}</strong>
                </ng-container>
              </p>
              <div class="bg-white dark:bg-gray-900 rounded-md p-2 md:p-3 border border-gray-300 dark:border-gray-600">
                <div class="flex items-start gap-2">
                  <div class="flex-1">
                    <div class="text-xs md:text-sm text-gray-700 dark:text-gray-300 mb-1 font-medium flex items-center gap-1">
                      <svg width="10" height="10" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" class="md:w-3 md:h-3">
                        <path d="M9.09981 6.99998V2.09998L2.7998 9.79998H7.69981V14.7L13.9998 6.99998H9.09981Z" fill="url(#paint0_linear_label_149_1520)"/>
                        <defs>
                          <linearGradient id="paint0_linear_label_149_1520" x1="2.7998" y1="8.39998" x2="13.9998" y2="8.39998" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#8300FF"/>
                            <stop offset="0.471154" stop-color="#B70AC4"/>
                            <stop offset="1" stop-color="#F21582"/>
                          </linearGradient>
                        </defs>
                      </svg>
                      Suggested change
                    </div>
                    <div class="text-xs md:text-sm font-mono text-gray-900 dark:text-white leading-relaxed bg-gray-100 dark:bg-gray-800 rounded-md p-2 md:p-3 mt-2">
                      <ng-container *ngFor="let segment of parseHighlights(item.suggestion)">
                        <span 
                          *ngIf="!segment.highlight"
                          >{{ segment.text }}</span>
                        <strong 
                          *ngIf="segment.highlight"
                          class="font-bold text-gray-900 dark:text-white"
                          >{{ segment.text }}</strong>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty state - no action items -->
          <div *ngIf="!result.actionRequired?.length" class="text-center py-4 md:py-6">
            <div class="text-3xl md:text-4xl mb-2 md:mb-3">🎉</div>
            <p class="text-xs md:text-sm font-medium text-green-600 dark:text-green-400">Your resume looks great!</p>
            <p class="text-[11px] md:text-xs text-gray-500 dark:text-gray-400 mt-1">No critical issues detected that would block your application.</p>
          </div>
        </div>

        <!-- 6. ADDITIONAL TIPS -->
        <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 md:p-5">
          <div class="mb-3 md:mb-4">
            <h3 class="text-base md:text-[18px] font-bold text-gray-900 dark:text-white mb-0.5">
              Additional tips 💡
            </h3>
            <p class="text-sm md:text-base text-gray-600 dark:text-gray-400">
              {{ result.additionalTips?.length ? 'Optional improvements to help you stand out from other candidates.' : 'No additional suggestions needed!' }}
            </p>
          </div>

          <!-- Has tips -->
          <div *ngIf="result.additionalTips?.length" class="space-y-3 md:space-y-4">
            <div 
              *ngFor="let tip of getVisibleTips()"
              class="bg-gray-50 dark:bg-gray-900/50 rounded-lg border-l-4 border-gray-300 dark:border-gray-600 p-3 md:p-5"
            >
              <div class="flex items-center gap-2 mb-1">
                <span class="font-semibold text-sm md:text-base text-gray-900 dark:text-white">{{ tip.category }}</span>
                <span class="px-2 py-0.5 rounded text-[9px] md:text-[10px] font-bold uppercase bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300">Optional</span>
              </div>
              <p class="text-xs md:text-sm text-gray-700 dark:text-gray-300 mb-2 md:mb-3">
                <ng-container *ngFor="let segment of parseHighlights(tip.description)">
                  <span 
                    *ngIf="!segment.highlight"
                    >{{ segment.text }}</span>
                  <strong 
                    *ngIf="segment.highlight"
                    class="font-bold text-gray-900 dark:text-white"
                    >{{ segment.text }}</strong>
                </ng-container>
              </p>
              <div class="bg-white dark:bg-gray-900 rounded-md p-2 md:p-3 border border-gray-300 dark:border-gray-600">
                <div class="flex items-start gap-2">
                  <div class="flex-1">
                    <div class="text-xs md:text-sm text-gray-700 dark:text-gray-300 mb-1 font-medium flex items-center gap-1">
                      <svg width="10" height="10" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" class="md:w-3 md:h-3">
                        <path d="M9.09981 6.99998V2.09998L2.7998 9.79998H7.69981V14.7L13.9998 6.99998H9.09981Z" fill="url(#paint0_linear_label_149_1520)"/>
                        <defs>
                          <linearGradient id="paint0_linear_label_149_1520" x1="2.7998" y1="8.39998" x2="13.9998" y2="8.39998" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#8300FF"/>
                            <stop offset="0.471154" stop-color="#B70AC4"/>
                            <stop offset="1" stop-color="#F21582"/>
                          </linearGradient>
                        </defs>
                      </svg>
                      Suggested change
                    </div>
                    <div class="text-xs md:text-sm font-mono text-gray-900 dark:text-white leading-relaxed bg-gray-100 dark:bg-gray-800 rounded-md p-2 md:p-3 mt-2">
                      <ng-container *ngFor="let segment of parseHighlights(tip.suggestion)">
                        <span 
                          *ngIf="!segment.highlight"
                          >{{ segment.text }}</span>
                        <strong 
                          *ngIf="segment.highlight"
                          class="font-bold text-gray-900 dark:text-white"
                          >{{ segment.text }}</strong>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Show all/less button -->
            <div *ngIf="result.additionalTips && result.additionalTips.length > 2" class="text-center mt-3">
              <button 
                (click)="toggleTips()"
                class="text-xs md:text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white font-medium"
              >
                {{ showAllTips ? 'Show less' : 'Show all' }}
              </button>
            </div>
          </div>

          <!-- Empty state - no tips -->
          <div *ngIf="!result.additionalTips?.length" class="text-center py-4 md:py-6">
            <div class="text-3xl md:text-4xl mb-2 md:mb-3">✨</div>
            <p class="text-xs md:text-sm font-medium text-blue-600 dark:text-blue-400">You're all set!</p>
            <p class="text-[11px] md:text-xs text-gray-500 dark:text-gray-400 mt-1">Your resume is well-optimized for this position.</p>
          </div>
        </div>

        <!-- 7. UPLOAD NEW RESUME -->
        <div class="rounded-xl px-4 md:px-6 py-8 md:py-10 border border-dashed bg-gray-100 dark:bg-black border-gray-400 dark:border-gray-700 text-center">
          <div class="flex items-center justify-center gap-3 md:gap-6">
            <!-- Illustration -->
            <div class="flex-shrink-0">
              <img 
                [src]="getTargetImage()" 
                alt="Target illustration" 
                class="w-20 h-16 md:w-28 md:h-24"
              />
            </div>

            <!-- Text and button -->
            <div class="text-left">
              <h4 class="font-bold text-gray-900 dark:text-white mb-0.5 md:mb-1 text-[16px] md:text-[22px]">
                Updated your resume?
              </h4>
              <p class="text-gray-600 dark:text-gray-400 mb-4 md:mb-3 text-sm md:text-[16px]">
                Upload the new version to see if your score improved
              </p>
              <button 
                (click)="runNewAnalysis()"
                class="inline-flex items-center gap-1.5 md:gap-2 px-4 md:px-6 py-2 md:py-2.5 bg-black dark:bg-white text-white dark:text-black rounded-full hover:bg-gray-800 dark:hover:bg-gray-100 transition-colors font-medium text-xs md:text-sm"
              >
                <hugeicons-icon
                  [icon]="icons.upload"
                  [size]="16"
                  color="currentColor"
                  [strokeWidth]="2"
                  class="block"
                />
                Upload file
              </button>
            </div>
          </div>
        </div>

      </div>

      <!-- 8. FOOTER -->
      <div class="border-t border-gray-200/50 dark:border-gray-700/50 px-4 md:px-6 py-4 md:py-5">
        <div class="flex justify-center gap-3">
          <button
            (click)="closeModal()"
            class="px-6 py-3 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 rounded-full hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors font-medium text-sm"
          >
            Close modal
          </button>
          <button
            (click)="applyToJob()"
            class="px-6 py-3 bg-black dark:bg-white text-white dark:text-black rounded-full hover:bg-gray-800 dark:hover:bg-gray-100 transition-colors font-medium text-sm"
          >
            Apply now
          </button>
        </div>
      </div>

    </div>
  </div>
</div>

